<template>
  <div class="benefits">
    <parachuter ref="parachuter" person="man" />
    <split-container class="benefits-container" direction="up" top-brand-color="green" bottom-brand-color="light-gray">

      <template v-slot:top>
        <div class="top-container">
          <div class="breadcrumb">02&nbsp;&mdash;&nbsp;Taste &amp; Nutrition</div>
          <div class="intro-text-container">

            <stacked-headline class="benefits-headline"
              top-text="Out of the World"
              top-color="dark-green"
              bottom-text="Taste"
              bottom-color="white">
            </stacked-headline>

            <p class="intro-text">It’s not just the color that makes this kiwi stand out. Zespri SunGold is naturally sweeter than the green variety with a tropical taste that some say is a cross between a mango and a strawberry.</p>
          </div>
        </div>
      </template>

      <template v-slot:bottom>
        <div class="bottom-container">
          <div class="nutritional-text">
            <h2 class="nutritional-headline">Explore this Nutritional Powerhouse Kiwifruit</h2>
            <p class="nutritional-text-body">This variety doesn't come with fuzz on the skin, but like the rest of its kiwifruit family, it's deliciously nutritious.</p>
            <p class="nutritional-callout">Packed with Nutrients&nbsp;<span class="nutritional-divider">|</span>&nbsp;Only 100 calories</p>
          </div>
          <div class="comparison-container">
            <div class="kiwi-comparison">
              <img class="kiwi-comparison-image" data-src="./assets/benefits/kiwi-spoon.png">
            </div>
            <div class="benefits-grid-container">
              <ul class="benefits-grid">
                <li class="benefit">
                  <c-icon class="benefit-icon"></c-icon>
                  <p>3x the vitamin c of a large orange</p>
                </li>
                <li class="benefit">
                  <glycemic-icon class="benefit-icon"></glycemic-icon>
                  <p>low glycemic index</p>
                </li>
                <li class="benefit">
                  <e-icon class="benefit-icon"></e-icon>
                  <p>good source of vitamin e</p>
                </li>
                <li class="benefit">
                  <fiber-icon class="benefit-icon"></fiber-icon>
                  <p>contains both insoluble and soluble fiber</p>
                </li>
                <li class="benefit">
                  <potassium-icon class="benefit-icon"></potassium-icon>
                  <p>as much potassium as a medium banana</p>
                </li>
                <li class="benefit">
                  <b-9-icon class="benefit-icon"></b-9-icon>
                  <p>natural source of folate</p>
                </li>
              </ul>
              <div class="disclaimer-text">*All comparisons are serving to serving. Get more information <a href="/en-US/nutrition" target="_blank">here.</a></div>
            </div>
          </div>
        </div>
      </template>
    </split-container>
    <img class="corner-fern" data-src="./assets/benefits/corner-fern.png">
  </div>
</template>

<script>
import SplitContainer from '../components/SplitContainer.vue'
import StackedHeadline from '../components/StackedHeadline.vue'
import Parachuter from '../components/Parachuter.vue'

import B9Icon from '../assets/icons/nutrition-b9-icon.svg?inline'
import CIcon from '../assets/icons/nutrition-c-icon.svg?inline'
import EIcon from '../assets/icons/nutrition-e-icon.svg?inline'
import FiberIcon from '../assets/icons/nutrition-fiber-icon.svg?inline'
import GlycemicIcon from '../assets/icons/nutrition-glycemic-icon.svg?inline'
import PotassiumIcon from '../assets/icons/nutrition-potassium-icon.svg?inline'

export default{
  name: 'benefits',
  components: {
    'split-container': SplitContainer,
    'stacked-headline': StackedHeadline,
    'parachuter': Parachuter,
    'b-9-icon' : B9Icon,
    'c-icon' : CIcon,
    'e-icon' : EIcon,
    'fiber-icon' : FiberIcon,
    'glycemic-icon' : GlycemicIcon,
    'potassium-icon' : PotassiumIcon
  },
  props: {
    active: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    active(active) {
      if (active) {
        this.$refs.parachuter.play()
      } else {
        this.$refs.parachuter.pause()
      }
    }
  }
}
</script>

<style unscoped lang="scss">
@import '../theme';

.benefits {
  .benefits-container {
    .bottom {
      z-index: zespri-layer(top-split);
    }
  }
}

</style>

<style scoped lang="scss">
/** benefits **/
@import '../theme';

.benefits {
  display: flex;
  flex-direction: column;
  text-align: left;

  @include media-breakpoint-up(lg) {
    min-height: 850px;
  }

  .benefits-container {
    background-color: zespri-brand-color(green);
  }
}

.container{
  @include media-breakpoint-up(lg) {
    min-height: 850px;
  }
}

.top-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-self: flex-start;
  padding: 32px 32px 0 32px;

  @include media-breakpoint-up(md) {
    padding: 2% 7vw 0 7vw;
  }

  @include media-breakpoint-up(lg) {
    padding: 2% 13% 0 8%;
  }

  @include media-breakpoint-up(xl) {
    padding: 2% 30% 0 8%;
  }
}

.corner-fern {
  position: absolute;
  top: 0;
  right: 0;
  width: 240px;
  z-index: zespri-layer(parachuter);

  @include media-breakpoint-up(md) {
    width: 21vw;
  }

  @include media-breakpoint-up(xl) {
    width: 415px;
  }
}

.breadcrumb {
  @include zespri-tiny-title;
  color: zespri-brand-color(dark-green);
}

.intro-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  margin-bottom: 60px;
  height: 100%;

  @include media-breakpoint-up(md) {
    // margin-top: 12vh;
  }

  @include media-breakpoint-up(lg) {
    flex-direction: row;
  }

  .benefits-headline {
    @include media-breakpoint-up(md) {
      margin-right: 8%;
    }

    @include media-breakpoint-up(xl) {
      margin-right: 10%;
    }
  }

  .intro-text {
    color: zespri-brand-color(dark-green);
  }
}

.bottom-container {
  display: flex;
  flex-direction: column;
  padding: 32px 32px 0 32px;

  @include media-breakpoint-up(md) {
    padding: 60px 0 0 32px;
  }

  @include media-breakpoint-up(lg) {
    padding: 0 0 0 32px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
  }

  @include media-breakpoint-up(xl) {
    padding: 0px 2% 0 7%;
  }

  .nutritional-text {

    @include media-breakpoint-up(lg) {
      width: 40%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }

    @include media-breakpoint-up(xl) {
      margin-right: 5%;
    }

    .nutritional-headline {
      @include zespri-small-callout;
      text-transform: capitalize;
      color: zespri-brand-color(dark-green);
      margin: 0 0 20px 0;
    }

    .nutritional-text-body {
      @include zespri-body;
      color: zespri-brand-color(dark-green);
      margin: 0 0 20px 0;
    }

    .nutritional-callout {
      @include zespri-mid-title;
      color: zespri-brand-color(green);
    }

    .nutritional-divider {
      color: zespri-brand-color(dark-green);
    }
  }

  .comparison-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include media-breakpoint-up(lg) {
      width: 60%;
      transform: translateY(-40%);
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      transform: none;
    }

    .kiwi-comparison {
      position: relative;

      @include media-breakpoint-up(xl) {
        width: 280px;
        margin-right: 2%;
      }

      .kiwi-comparison-image {
        width: 100%;
        max-width: 300px;

        @include media-breakpoint-up(lg) {
          max-width: 150px;
        }

        @include media-breakpoint-up(xl) {
          position: absolute;
          top: -4vw;
          max-width: 345px;
        }
      }
    }

    .benefits-grid-container {

      @include media-breakpoint-up(md) {
        max-width: 60%;
      }

      @include media-breakpoint-up(lg) {
        margin: 60px 0 0 20px;
      }

      .benefits-grid {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        list-style: none;
        padding: 0;
        margin: 0;

        .benefit {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          box-sizing: border-box;
          width: calc(50% - 20px);
          margin: 10px;

          @include media-vertical-breakpoint-up(md) {
            font-size: 12px;
            margin: 15px;
            width: calc(50% - 30px);
          }

          .benefit-icon {
            width: 36px;
            height: 36px;
            margin-bottom: 15px;
            fill: zespri-brand-color(red);
          }

          p {
            @include zespri-title-font;
            font-size: 11px;
            margin: 0;
            
            @include media-vertical-breakpoint-up(md) {
              font-size: 12px;
            }
          }
        }
      }
      .disclaimer-text {
        @include zespri-body-font;
        color: zespri-color(grayscale, 400);
        font-size: 11px;
        text-align: center;
        margin: 15px 0;
        
        a {
          color: zespri-color(grayscale, 400);
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
